<template>
  <div class="u-pad-x-1of12 u-pad-y-xl u-pad-y-md--sm" :class="'u-' + data.ctaPosition">
    <app-button :url="data.href" >
      <span class="t-text">
        {{ data.titre }}
      </span>
    </app-button>
  </div>
</template>

<script>
import AppButton from '@/components/common/AppButton'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    AppButton
  }
}
</script>